/* Cart Drawer Pro extras - Olyx Fashion.
   Two-stage milestone (free shipping at the real threshold, free gift at the
   gift threshold) plus a small always-on shipping-protection toggle.

   Sep 2026: shipping is NOT free on every order. Below the threshold checkout
   charges shipping; the automatic discount "Free Shipping over €50" removes
   it from 50 in the store currency (USD), converted to the visitor's
   currency. The drawer now uses that same number, so it never says
   "free shipping" for a cart that checkout will charge for.
   Runs alongside cdp-cart.js and listens to the cdp:updated event it fires.
   Loaded BEFORE cdp-cart.js so the listener is attached before the first render. */
(function () {
  'use strict';

  var root = document.getElementById('CartDrawerPro');
  if (!root || root.dataset.cdpExtras) return;
  root.dataset.cdpExtras = '1';

  function readJSON(id, fallback) {
    var el = document.getElementById(id);
    if (!el) return fallback;
    try { return JSON.parse(el.textContent); } catch (e) { return fallback; }
  }

  var X = readJSON('CartDrawerProExtras', {});
  /* real free-shipping threshold in the visitor's currency, in cents.
     Read on every paint: the page config may load after this file. */
  function shipMin() {
    var cfg = window.OlyxFixesConfig;
    if (cfg && typeof cfg.freeShippingExact === 'number') return Math.round(cfg.freeShippingExact * 100);
    var rate = 1;
    try { rate = parseFloat(window.Shopify && window.Shopify.currency && window.Shopify.currency.rate) || 1; } catch (e) {}
    return Math.round(5000 * rate); /* 50 USD, same as the discount minimum */
  }
  /* free-gift threshold in the visitor's currency (cents); see snippets/olyx-fixes.liquid */
  function giftMin() {
    /* Oct 2026: no free gift any more - the bar tops out at free shipping */
    if (!(Number(X.giftVariantId) || X.giftHandle)) return shipMin();
    var c = window.OlyxFixesConfig;
    if (c && c.giftExact) return Math.round(c.giftExact * 100);
    var rate = 1;
    try { rate = parseFloat(window.Shopify && window.Shopify.currency && window.Shopify.currency.rate) || 1; } catch (e) {}
    return Math.round(15000 * rate);
  }
  function giftShownCents() {
    var c = window.OlyxFixesConfig;
    return (c && c.giftShown) ? Math.round(c.giftShown * 100) : giftMin();
  }
  var PROT_VID = Number(X.protectionVariantId) || 0;
  var PROT_PRICE = Number(X.protectionPrice) || 0;
  var GIFT_VID = Number(X.giftVariantId) || 0;
  var FMT = X.moneyFormat || '{{amount_with_comma_separator}}';

  var RE_THOUSANDS = new RegExp('([0-9])(?=([0-9][0-9][0-9])+(?![0-9]))', 'g');
  var RE_PLACEHOLDER = new RegExp('[{][{][ ]*([a-z_]+)[ ]*[}][}]', 'g');

  function money(cents) {
    cents = Number(cents) || 0;
    function num(v, p, t, d) {
      var parts = (v / 100).toFixed(p).split('.');
      var whole = parts[0].replace(RE_THOUSANDS, '$1' + t);
      return p ? whole + d + parts[1] : whole;
    }
    return FMT.replace(RE_PLACEHOLDER, function (m, key) {
      switch (key) {
        case 'amount': return num(cents, 2, ',', '.');
        case 'amount_no_decimals': return num(cents, 0, ',', '.');
        case 'amount_with_comma_separator': return num(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return num(cents, 0, '.', ',');
        case 'amount_with_space_separator': return num(cents, 2, ' ', ',');
        case 'amount_no_decimals_with_space_separator': return num(cents, 0, ' ', ',');
        default: return num(cents, 2, ',', '.');
      }
    });
  }

  var $ = function (sel) { return root.querySelector(sel); };
  var ms = $('[data-cdp-ms]');
  var msText = $('[data-cdp-ms-text]');
  var msFill = $('[data-cdp-ms-fill]');
  var msShip = $('[data-cdp-ms-ship]');
  var msGift = $('[data-cdp-ms-gift]');
  var prot = $('[data-cdp-prot]');
  var protSw = $('[data-cdp-prot-sw]');
  var protPrice = $('[data-cdp-prot-price]');

  function isProt(i) { return !!PROT_VID && Number(i.variant_id) === PROT_VID; }
  var GIFT_HANDLE = X.giftHandle || '';
  function isGift(i) {
    if (!(i.properties && i.properties._olyx_gift)) return false;
    return (!!GIFT_HANDLE && i.handle === GIFT_HANDLE) || (!!GIFT_VID && Number(i.variant_id) === GIFT_VID);
  }

  function merchandiseSubtotal(cart) {
    return (cart.items || []).reduce(function (n, i) {
      return n + (isProt(i) || isGift(i) ? 0 : i.final_line_price);
    }, 0);
  }
  function realCount(cart) {
    return (cart.items || []).reduce(function (n, i) {
      return n + (isProt(i) || isGift(i) ? 0 : i.quantity);
    }, 0);
  }
  function setDeclined(v) {
    try {
      if (v) { sessionStorage.setItem('cdp_protect_off', '1'); }
      else { sessionStorage.removeItem('cdp_protect_off'); }
    } catch (e) {}
  }

  var RE_AMP = new RegExp('&', 'g');
  var RE_LT = new RegExp('<', 'g');
  var RE_GT = new RegExp('>', 'g');
  function esc(t) {
    return String(t == null ? '' : t)
      .replace(RE_AMP, '&amp;').replace(RE_LT, '&lt;').replace(RE_GT, '&gt;');
  }

  function paint(cart) {
    if (!cart) return;
    var sub = merchandiseSubtotal(cart);
    var n = realCount(cart);
    var SHIP_MIN = shipMin();
    var GIFT_MIN = giftMin();
    /* legend under the bar: "Free gift · $150" in the visitor's currency */
    if (msGift) {
      var label = msGift.lastChild;
      while (label && label.nodeType !== 3) label = label.previousSibling;
      var txt = (X.giftLabel || 'Free gift') + ' · ' + money(giftShownCents()).replace(/[.,]00(?!\d)/, '');
      if (label && label.nodeValue.trim() !== txt) label.nodeValue = ' ' + txt;
    }

    if (ms) {
      ms.hidden = n === 0;
      var pct = GIFT_MIN > 0 ? Math.round((sub / GIFT_MIN) * 100) : 100;
      pct = Math.max(0, Math.min(100, pct));
      if (msFill) msFill.style.width = pct + '%';
      if (msText) {
        if (sub >= GIFT_MIN) {
          msText.innerHTML = esc(X.textGift || 'Free shipping and your free gift are unlocked');
        } else if (sub >= SHIP_MIN) {
          msText.innerHTML = esc(X.textMid || 'Free shipping unlocked - [amount] away from your free gift')
            .replace('[amount]', '<b>' + money(GIFT_MIN - sub) + '</b>');
        } else {
          /* below the threshold: say how far away free shipping is (the old
             "Free shipping on every order" text was not true at checkout) */
          msText.innerHTML = esc(X.textBelow || 'Add [amount] more for free shipping')
            .replace('[amount]', '<b>' + money(SHIP_MIN - sub) + '</b>');
        }
      }
      if (msShip) msShip.classList.toggle('is-on', sub >= SHIP_MIN);
      if (msGift) msGift.classList.toggle('is-on', sub >= GIFT_MIN);
    }

    if (prot && PROT_VID) {
      prot.hidden = n === 0;
      var on = (cart.items || []).some(isProt);
      prot.classList.toggle('is-on', on);
      if (protSw) protSw.setAttribute('aria-checked', on ? 'true' : 'false');
      if (protPrice) protPrice.textContent = money(PROT_PRICE);
    }
  }

  document.addEventListener('cdp:updated', function (e) {
    paint(e && e.detail && e.detail.cart);
  });

  function post(url, payload) {
    return fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload)
    }).then(function (r) { return r.json(); });
  }

  function finish() {
    if (prot) prot.classList.remove('is-busy');
    document.dispatchEvent(new CustomEvent('cart:refresh'));
  }

  if (protSw) {
    protSw.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      if (!PROT_VID || !prot || prot.classList.contains('is-busy')) return;
      var on = protSw.getAttribute('aria-checked') === 'true';
      prot.classList.add('is-busy');
      prot.classList.toggle('is-on', !on);
      protSw.setAttribute('aria-checked', on ? 'false' : 'true');

      if (on) {
        setDeclined(true);
        fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (c) {
            var line = (c.items || []).filter(isProt)[0];
            if (!line) return null;
            return post('/cart/change.js', { id: line.key, quantity: 0 });
          })
          .then(finish, finish);
      } else {
        setDeclined(false);
        post('/cart/add.js', { items: [{ id: PROT_VID, quantity: 1 }] }).then(finish, finish);
      }
    });
  }

  paint(readJSON('CartDrawerProCart', null));
})();
